import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { HttpHeaders } from "../httpHeaders";
/**
 * Authenticates to a service using an API key.
 */

export var ApiKeyCredentials = /*#__PURE__*/function () {
  /**
   * @param options - Specifies the options to be provided for auth. Either header or query needs to be provided.
   */
  function ApiKeyCredentials(options) {
    _classCallCheck(this, ApiKeyCredentials);

    if (!options || options && !options.inHeader && !options.inQuery) {
      throw new Error("options cannot be null or undefined. Either \"inHeader\" or \"inQuery\" property of the options object needs to be provided.");
    }

    this.inHeader = options.inHeader;
    this.inQuery = options.inQuery;
  }
  /**
   * Signs a request with the values provided in the inHeader and inQuery parameter.
   *
   * @param webResource - The WebResourceLike to be signed.
   * @returns The signed request object.
   */


  _createClass(ApiKeyCredentials, [{
    key: "signRequest",
    value: function signRequest(webResource) {
      if (!webResource) {
        return Promise.reject(new Error("webResource cannot be null or undefined and must be of type \"object\"."));
      }

      if (this.inHeader) {
        if (!webResource.headers) {
          webResource.headers = new HttpHeaders();
        }

        for (var headerName in this.inHeader) {
          webResource.headers.set(headerName, this.inHeader[headerName]);
        }
      }

      if (this.inQuery) {
        if (!webResource.url) {
          return Promise.reject(new Error("url cannot be null in the request object."));
        }

        if (webResource.url.indexOf("?") < 0) {
          webResource.url += "?";
        }

        for (var key in this.inQuery) {
          if (!webResource.url.endsWith("?")) {
            webResource.url += "&";
          }

          webResource.url += "".concat(key, "=").concat(this.inQuery[key]);
        }
      }

      return Promise.resolve(webResource);
    }
  }]);

  return ApiKeyCredentials;
}();